import { useTranslation } from 'react-i18next';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { useCallback, useState } from 'react';
import { refreshIconAnimated } from '@cas/components/icons/icons';
import type { TagDescription } from '@reduxjs/toolkit/query';

export interface RefreshButtonControllerProps<T> {
  tagsToClear: TagDescription<T>[];
}

interface RefreshButtonProps {
  invalidateTagsCallback: () => void;
}

export const RefreshButton = ({ invalidateTagsCallback }: RefreshButtonProps) => {
  const { t } = useTranslation();

  const [disabled, setDisabled] = useState<boolean>(false);

  const onRefresh = useCallback(() => {
    // Disable the button for 2s after being clicked.
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, 2000);

    // Invalidate the specified tags to trigger automatic refetching of any matching querys that are mounted.
    invalidateTagsCallback();
  }, [invalidateTagsCallback]);

  return (
    <VdsButton variant="secondary" onClick={onRefresh} disabled={disabled}>
      {t('Refresh')}
      <VdsIcon slot="icon-left" svgIcon={disabled ? refreshIconAnimated : 'refresh'} />
    </VdsButton>
  );
};

export default RefreshButton;
